<template>
  <div>
    <v-menu
      v-if="!$vuetify.display.mobile"
      v-model="menuVisible"
      :transition="false"
      :min-width="popupMinWidth"
      :offset="iconOffset"
      :attach="popupAttach"
      location="left"
      @update:model-value="$emit('update:model-value', $event)"
    >
      <template #activator="{ props }" v-if="!hideActivator">
        <slot name="activator" :props="props">
          <the-button
            v-bind="props"
            icon
            :custom-colors="activatorCustomColors"
            :aria-label="$translate('MenuButton.ariaMore')"
            class="menu-button"
            @click.stop.prevent
          >
            <i-custom-options-vertical />
          </the-button>
        </slot>
      </template>

      <app-card no-shadow class="list-items-container">
        <v-list class="d-flex flex-column fill-width pa-0">
          <slot />
        </v-list>
      </app-card>
    </v-menu>

    <v-bottom-sheet v-else v-model="menuVisible" close-on-content-click class="menu-bottom-sheet" @update:model-value="$emit('update:model-value', $event)">
      <template #activator="{ props }" v-if="!hideActivator">
        <slot name="activator" :props="props">
          <the-button
            v-bind="props"
            icon
            :custom-colors="activatorCustomColors"
            :aria-label="$translate('MenuButton.ariaMore')"
            class="menu-button"
            @click.stop.prevent
          >
            <i-custom-options-vertical />
          </the-button>
        </slot>
      </template>

      <app-card class="list-items-container top-radius pb-8">
        <v-card-title>
          <div class="d-flex align-center justify-space-between">
            <the-button small icon custom-colors class="color-post-detail" @click="menuVisible = false">
              <i-custom-close />
            </the-button>
            <div v-if="mobileTitle" class="mobile-title-container font-size-big font-weight-bold">{{ mobileTitle }}</div>
            <div class="mobile-header-placeholder" />
          </div>
        </v-card-title>
        <slot name="content-above" />
        <v-list class="d-flex flex-column fill-width pa-0">
          <slot />
        </v-list>
      </app-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
export default {
  props: {
    popupMinWidth: {
      type: Number,
      default: 120
    },
    popupAttach: {
      type: [String, Boolean],
      default: false
    },
    activatorCustomColors: {
      type: Boolean,
      default: false
    },
    mobileTitle: {
      type: String,
      default: null
    },
    hideActivator: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menuVisible: false,
      iconOffset: 32
    }
  },
  watch: {
    menuVisible(newValue) {
      if (newValue) {
        this.$emit("open")
      } else {
        this.$emit("close")
      }
    }
  },
  methods: {
    openMenu() {
      this.menuVisible = true
    },
    isOpened() {
      return this.menuVisible
    }
  }
}
</script>

<style lang="scss" scoped>
.v-menu :deep(.v-overlay__content) {
  box-shadow: var(--shadow-1) !important;
  border-radius: var(--rounded-app);

  .v-list .v-btn {
    border-radius: 0 !important;
    font-weight: normal !important;

    .v-btn__content {
      justify-content: flex-start;
    }
  }
}
</style>

<style lang="scss">
.menu-bottom-sheet {
  .mobile-title-container {
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    text-align: center;
  }

  .v-list {
    padding-bottom: var(--safe-area-bottom) !important;
  }

  .v-list .v-btn__content {
    justify-content: flex-start;
  }

  .app-card {
    &.top-radius {
      border-top-left-radius: 20px !important;
      border-top-right-radius: 20px !important;
    }
  }
}
</style>
